// extracted by mini-css-extract-plugin
export default {"container":"center-panel_container__S+lr5","--show":"center-panel_--show__YpY72","--mobile":"center-panel_--mobile__X4vYw"};